export default "__VITE_ASSET__CJkFobSQ__"